import { IApplicationState } from '../../types/redux';

export const getAnswerText = (state: IApplicationState): string => {
  return state.newAnswer.data.answer.value;
};
